import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propShape, propStr } from '../../../helpers/custom-prop-types';
import { validateFirstName, validateLastName } from '../../../validate/common';
import MultiInputFields from '../Common/Fields/MultiInputFields';
const FullNameFieldsAndLabel = ({ form, nameFirstName, nameLastName, wrapperClassName, }) => (_jsxs("div", Object.assign({ className: wrapperClassName }, { children: [_jsx("h3", { children: "\u6C0F\u540D" }), _jsx(MultiInputFields, { className: 'is-half', form: form, settings: [
                {
                    name: nameLastName,
                    placeholder: '姓',
                    validate: validateLastName,
                },
                {
                    name: nameFirstName,
                    placeholder: '名',
                    validate: validateFirstName,
                },
            ] })] })));
FullNameFieldsAndLabel.propTypes = {
    form: propShape().isRequired,
    nameFirstName: propStr().isRequired,
    nameLastName: propStr().isRequired,
    wrapperClassName: propStr(),
};
FullNameFieldsAndLabel.defaultProps = {
    wrapperClassName: 'form form-narrow cf',
};
export default FullNameFieldsAndLabel;
